import Layout from '@/components/layout/Layout.vue'
import { VueCropper } from 'vue-cropper'
import api from "@/config/api"
import request from '@/utils/request'
import { storeOrUpdateMaterial } from '@/api/local-material'

const platform = localStorage.getItem('platform')

export default {
    components: {
        Layout,
        VueCropper,
    },
    props: {
        showCropper: {
            type: Boolean,
            required: true
        },
        model: {
            type: Object,
            default: () => null
        },
    },
    data() {
        return {
            uploadUrl: `${api.baseUrl}/${platform}/open/upload_file`,
            labelCol: { span: 4 },
            wrapperCol: { span: 18 },
            accounts: [],
            loading: false,
            rules: {
                account_id: [{ required: true, message: '请选择授权账号', trigger: 'change' }],
            },
            showImg: false,
            croppedImage: null,
            modelSrc: '',
            crap: false,
            previews: {},
            form: {
                head: ''
            },
            option: {
                img: '', // 裁剪图片的地址 url 地址, base64, blob
                outputSize: 1, // 裁剪生成图片的质量
                info: true, // 裁剪框的大小信息
                canScale: true, // 图片是否允许滚轮缩放
                autoCrop: true, // 是否默认生成截图框
                fixedBox: false, // 固定截图框大小 不允许改变
                fixed: false, // 是否开启截图框宽高固定比例
                fixedNumber: null, // 截图框的宽高比例 [ 宽度 , 高度 ]
                canMove: true, // 上传图片是否可以移动
                canMoveBox: true, // 截图框能否拖动
                original: false, // 上传图片按照原始比例渲染
                centerBox: true, // 截图框是否被限制在图片里面
                infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
                full: true, // 是否输出原图比例的截图
                enlarge: 1, // 图片根据截图框输出比例倍数
                mode: 'contain' // 图片默认渲染方式 contain , cover, 100px, 100% auto
            },
            downImg: '#',
            result: [],
            fixedType: 3,
            multiple: 0.6,
        }
    },
    created() {
        this.init(this.option)
       
    },
    computed: {
    },
    mounted() {
        this.option.img = this.model.file_url
    },
    methods: {
        changeScale(num) { 
            this.$refs.cropper.changeScale(num) 
        },
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    return false
                }
                this.pull()
            });
        },
        close() {
            this.$emit('update:showCropper', false)
        },
        handleCancel() {
            this.$emit('update:showCropper', false)
        },
        //初始化
        init(obj) {
            if (obj.img) {
                this.option.img = obj.img
            }
            //裁剪生成图片的质量
            this.option.outputSize = 1

            //裁剪框的大小信息
            if (obj.info) {
                this.option.info = obj.info
            } else {
                this.option.info = true
            }
            //图片是否允许滚轮缩放
            if (obj.canScale) {
                this.option.canScale = obj.canScale
            } else {
                this.option.canScale = false
            }
            //是否默认生成截图框
            if (obj.autoCrop) {
                this.option.autoCrop = obj.autoCrop
            } else {
                this.option.autoCrop = true
            }


            // //默认生成截图框宽度
            // if (obj.autoCropWidth) {
            //     this.option.autoCropWidth = obj.autoCropWidth
            // } else {
            //     this.option.autoCropWidth = 375
            // }
            // //默认生成截图框高度
            // if (obj.autoCropHeight) {
            //     this.option.autoCropHeight = obj.autoCropHeight
            // } else {
            //     this.option.autoCropHeight = 245
            // }


            //固定截图框大小 不允许改变
            if (obj.fixedBox) {
                this.option.fixedBox = obj.fixedBox
            } else {
                this.option.fixedBox = false
            }
            //是否开启截图框宽高固定比例
            if (obj.fixed) {
                this.option.fixed = obj.fixed
            } else {
                this.option.fixed = false
            }

            //上传图片是否可以移动
            if (obj.canMove) {
                this.option.canMove = obj.canMove
            } else {
                this.option.canMove = true
            }
            //截图框能否拖动
            if (obj.canMoveBox) {
                this.option.canMoveBox = obj.canMoveBox
            } else {
                this.option.canMoveBox = true
            }
            //上传图片按照原始比例渲染
            if (obj.original) {
                this.option.original = obj.original
            } else {
                this.option.original = false
            }
            //截图框是否被限制在图片里面
            if (obj.centerBox) {
                this.option.centerBox = obj.centerBox
            } else {
                this.option.centerBox = true
            }
            //true 为展示真实输出图片宽高 false 展示看到的截图框宽高
            if (obj.infoTrue) {
                this.option.infoTrue = obj.infoTrue
            } else {
                this.option.infoTrue = true
            }
            //是否输出原图比例的截图
            if (obj.full) {
                this.option.full = obj.full
            } else {
                this.option.full = true
            }
            //图片根据截图框输出比例倍数
            if (obj.enlarge) {
                this.option.enlarge = obj.enlarge
            } else {
                this.option.enlarge = 1
            }
            //图片默认渲染方式
            if (obj.mode) {
                this.option.mode = obj.mode
            } else {
                this.option.mode = 'contain'
            }
            if (obj.success) {
                this.success = obj.success
            } else {
                this.success = () => {
                }
            }
        },
        //裁剪
        finish() {
            this.changeFixed(this.fixedType)
            this.$refs.cropper.getCropData((data) => {
                this.modelSrc = data
                this.showImg = true;
                //裁剪后的图片显示
                this.option.img = this.modelSrc;
                this.option.autoCrop = false
            })
        },
        //下载
        downLoad() {
            if (this.modelSrc == '') {
                this.$message.error('请先选择图片！')
                return
            }
            let url = this.modelSrc
            fetch(url).then(res => res.blob()).then(blob => {//将链接字符地址转换成blob地址
                const aLink = document.createElement('a')
                aLink.href = URL.createObjectURL(blob)
                aLink.download = Date.now() + '.jpg'
                document.body.appendChild(aLink)
                aLink.click()
                aLink.remove()
            })
        },
        ok() {
            this.$refs.cropper.getCropBlob(data => {
                // 这里data数据为Blob类型，blobToDataURI方法转换成base64
                this.blobToDataURI(data, function (res) {
                    console.log('base64格式：', res)
                })
            })
        },
        //上传图片
        uploadImg() {
            if (this.modelSrc == '') {
                this.$message.error('请先选择图片！')
                return
            }
            let url = this.modelSrc

            this.loading = true
            try {
                fetch(url).then(res => res.blob()).then(blob => {//将链接字符地址转换成blob地址
                    // 创建一个 FormData 对象，并将文件对象添加到其中
                    const formData = new FormData();
                    formData.append('upload', blob, this.model.name + '.' + this.getFileExtension(this.model.file_url));

                    // 发起 POST 请求
                    request.post(this.uploadUrl, formData).then(res => {
                        this.$message.destroy()
                        if (res && res.code === 0) {
                            let materials = []
                            let element = res.data
                            let name = element.originalFilename + '_' + element.width + '_' + element.height
                            
                            //组装数据
                            let thisData = {}
                            thisData.remark = '图片剪裁'
                            thisData.name = name
                            thisData.size = element.fileSize
                            thisData.type = element.type
                            thisData.width = element.width
                            thisData.height = element.height
                            thisData.code = element.md5Code
                            thisData.video_cover = element.video_cover
                            thisData.file_url = element.url
                            materials.push(thisData)

                            let json = {};
                            json.type = 2,
                            json.pid = this.model.pid,
                            json.size = element.fileSize
                            json.type = element.type
                            json.width = element.width
                            json.height = element.height

                            json.name = name
                            json.code = element.md5Code
                            json.video_cover = element.video_cover
                            json.file_url = element.url
                            json.remark = '图片剪裁'
                            
                            //开始提交素材
                            json.materials = materials
                            storeOrUpdateMaterial(json).then(res2 => {
                                this.$message.destroy()
                                if (res2 && res2.code === 0) {
                                    this.$message.success('上传成功')
                                    this.$emit('success')
                                    this.close()
                                } else {
                                    this.$message.error(res2.message)
                                }
                                this.loading = false
                            }).catch(() => {
                                this.loading = false
                            })
                     
                        } else {
                            this.$message.error(res.message)
                        }
                        this.loading = false
                    }).catch(() => {
                        this.loading = false
                    })

                    // const response = request.post(this.uploadUrl, formData);
                    // let returnData = response
                   
                })

            } catch (error) {
                this.loading = false
                this.$message.error('上传失败：' + error)
            }
        },
        getFileExtension(url) {
            // 使用split方法将URL按斜杠分割成数组
            const urlParts = url.split('/');

            // 获取数组中的最后一个元素，即文件名
            const fileName = urlParts[urlParts.length - 1];

            // 使用split方法将文件名按点号分割成数组
            const fileNameParts = fileName.split('.');

            // 获取数组中的最后一个元素，即文件后缀
            const fileExtension = fileNameParts[fileNameParts.length - 1];
            return fileExtension
        },
        //url转base64
        blobToDataURI(blob, callback) {
            var reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onload = function (e) {
                callback(e.target.result);
            }
        },
        changeFixed(val) {
            this.option.fixed = false
            this.option.fixedNumber = null

            this.multiple = 0.6
            if (val == 1) {
                this.option.fixed = true
                this.option.fixedNumber = [1, 1]
                this.multiple = 1
            } else if (val == 2) {
                this.option.fixed = true
                this.option.fixedNumber = [2, 1]
                this.multiple = 2
            } else if (val == 3) {
                this.option.fixed = true
                this.option.fixedNumber = [3, 5]
                this.multiple = 0.6
            } else {
                this.option.fixed = false
                this.option.fixedNumber = null
                this.multiple = 0
            }
          
            this.fixedType = val;
            this.realTime()
        },
        realTime() {
            if (this.$refs.cropper) {
                let width = Math.ceil(this.$refs.cropper.cropW)
                if (width === 0 || this.multiple === 0) {
                    return false
                }
           
                let multiple = this.multiple
                    // 找到满足条件的整数宽度和高度
                let a = 0
                // 调整宽度和高度，直到满足宽高比为0.6
                while (this.$refs.cropper.cropInfo.width / this.$refs.cropper.cropInfo.height !== multiple) {
                    a++
                    if ( a>10 ) {
                        break
                    }
                    // console.log("开始循环bbb："+a, this.$refs.cropper.cropInfo.width, this.$refs.cropper.cropInfo.height)
                    if (this.$refs.cropper.cropInfo.width / this.$refs.cropper.cropInfo.height > multiple) {
                        this.$refs.cropper.cropW--;
                    } else {
                        this.$refs.cropper.cropH--;
                        this.$refs.cropper.cropW = Math.round(this.$refs.cropper.cropH * multiple);
                    }
                }

                let thisRate =  this.$refs.cropper.cropInfo.width/this.$refs.cropper.cropInfo.height
                // console.log('c',this.$refs.cropper.cropInfo,  thisRate)

                if (thisRate != multiple) {
                    console.log('不满足比例，重新开始')
                    // this.changeFixed(this.fixedType)
                }
            }
        }

    }
}
